import "./gazetteer.3961bf1c.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire558e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire558e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $1pM69 = parcelRequire("1pM69");
const $3016b9d1bca02dc1$var$tilesContainerId = 'lbht-walks-tiles';
const $3016b9d1bca02dc1$var$tilesFilterId = 'walks-filters';
const $3016b9d1bca02dc1$var$tilesSelector = '.walks-selector';
let $3016b9d1bca02dc1$var$tilesContainerElement;
let $3016b9d1bca02dc1$var$tilesFilterElement;
// Plain Javascript DOM callback(s)
let $3016b9d1bca02dc1$var$callback = function() {
    // Handler when the DOM is fully loaded
    // get the element to for the Walks Tiles and Filter
    $3016b9d1bca02dc1$var$tilesContainerElement = document.getElementById($3016b9d1bca02dc1$var$tilesContainerId);
    $3016b9d1bca02dc1$var$tilesFilterElement = document.getElementById($3016b9d1bca02dc1$var$tilesFilterId);
    // create a new isoTope object with the new set of tiles
    let isoTopeObject = new (0, (/*@__PURE__*/$parcel$interopDefault($1pM69)))($3016b9d1bca02dc1$var$tilesContainerElement, {
        itemSelector: $3016b9d1bca02dc1$var$tilesSelector,
        layoutMode: 'fitRows'
    });
    // set the on-click events for the filter items
    const onClickFunction = isoFilterSelectFunc(isoTopeObject);
    const lis = $3016b9d1bca02dc1$var$tilesFilterElement.querySelectorAll('li');
    lis.forEach((element)=>{
        element.addEventListener('click', function() {
            onClickFunction(this);
        });
    });
    // creates a closure for the filter onclick events
    // the global isoTope object is used by the closure
    function isoFilterSelectFunc(isoTopeObj) {
        return function(element) {
            element.parentElement.querySelectorAll('li').forEach((e)=>{
                e.classList.remove("active");
            });
            element.classList.add("active");
            let filterValue = element.getAttribute('data-filter');
            isoTopeObj.arrange({
                filter: filterValue
            });
        };
    }
};
// End of DOM Callback Function(s)
if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) $3016b9d1bca02dc1$var$callback();
else document.addEventListener("DOMContentLoaded", $3016b9d1bca02dc1$var$callback);


//# sourceMappingURL=walks_orig.9901b346.js.map
